<template>
  <section class="cta-section">
    <div class="cta-container">

      <!-- 左侧内容区 -->
      <div class="left-content">
        <div class="tag">● CRYPTO FRAUD RECOVERY UNIT</div>

        <h1 class="main-title">
          Trace It. Report It.<br>
          <span class="gradient-text">Recover It.</span>
        </h1>

        <p class="description">
          Blockchain forensic investigation for victims of crypto fraud — from phishing and rug pulls to fake investment
          platforms. We map every transaction until your case has a clear path forward.
        </p>

        <div class="buttons">
          <button class="btn-primary">⚡ START INVESTIGATION</button>
          <button class="btn-secondary">▶ FREE CONSULTATION</button>
        </div>

        <div class="stats">
          <div class="stat-item"><span class="stat-dot"></span> 10+ Active Services</div>
          <div class="stat-item"><span class="stat-dot"></span> 40+ Countries Served</div>
          <div class="stat-item"><span class="stat-dot"></span> 24/7 Case Monitoring</div>
        </div>
      </div>

      <!-- 右侧视觉区 (纯 CSS 绘制) -->
      <div class="right-visual">

        <!-- 四个角标 -->
        <div class="corner c-tl"></div>
        <div class="corner c-tr"></div>
        <div class="corner c-bl"></div>
        <div class="corner c-br"></div>

        <!-- 地球与轨道 -->
        <div class="globe-container">
          <div class="globe-sphere"></div>
          <!-- 内部旋转的虚线球体 -->
          <div class="dashed-sphere"></div>
          <div class="orbit orbit-1"></div>
          <div class="orbit orbit-2"></div>
          <div class="orbit orbit-3"></div>

          <!-- 散落的绿点 -->
          <div class="dot d1"></div>
          <div class="dot d2"></div>
          <div class="dot d3"></div>
          <div class="dot d4"></div>
          <div class="dot d5"></div>
        </div>

        <!-- 四个浮动标签（带上下浮动动画） -->
        <div class="floating-label label-1"><span class="label-dot"></span> TRACE_ACTIVE</div>
        <div class="floating-label label-2"><span class="label-dot"></span> CASE_SECURE</div>
        <div class="floating-label label-3"><span class="label-dot"></span> GLOBAL_REACH</div>
        <div class="floating-label label-4"><span class="label-dot"></span> ENCRYPTED</div>

      </div>

    </div>
  </section>
</template>

<script>
export default {
  name: 'CtaSection'
}
</script>

<style scoped>
.cta-section {
  background-color: #070b14;
  padding: 100px 5%;
  color: #fff;
}

.cta-container {
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 60px;
}

/* 左侧内容 */
.left-content {
  flex: 1;
  max-width: 600px;
}

.tag {
  color: #00ff88;
  font-size: 0.8rem;
  /* 字体小一点 */
  font-family: monospace;
  letter-spacing: 1px;
  margin-bottom: 25px;
}

.main-title {
  font-size: 3.5rem;
  /* 字体小一点 */
  line-height: 1.1;
  font-weight: 800;
  margin: 0 0 25px;
}

.gradient-text {
  background: linear-gradient(90deg, #00ff88, #4fd1c5);
  -webkit-background-clip: text;
  color: transparent;
  display: inline-block;
}

.description {
  font-size: 1.1rem;
  /* 字体小一点 */
  line-height: 1.8;
  color: #a0b3cc;
  margin-bottom: 40px;
}

/* 按钮组 */
.buttons {
  display: flex;
  gap: 20px;
  margin-bottom: 50px;
}

.btn-primary {
  background: linear-gradient(90deg, #00d68f, #00ff88);
  border: none;
  color: #000;
  padding: 16px 30px;
  font-size: 0.95rem;
  /* 字体小一点 */
  font-weight: bold;
  border-radius: 6px;
  cursor: pointer;
  box-shadow: 0 0 20px rgba(0, 255, 136, 0.3);
  transition: transform 0.3s;
}

.btn-primary:hover {
  transform: translateY(-3px);
}

.btn-secondary {
  background: transparent;
  border: 1px solid #2a303c;
  color: #fff;
  padding: 16px 30px;
  font-size: 0.95rem;
  /* 字体小一点 */
  font-weight: bold;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s;
}

.btn-secondary:hover {
  border-color: #00ff88;
  color: #00ff88;
}

/* 底部统计条 */
.stats {
  display: flex;
  gap: 40px;
  font-family: monospace;
  font-size: 0.85rem;
  /* 字体小一点 */
  color: #a0b3cc;
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.stat-dot {
  width: 6px;
  height: 6px;
  background: #00ff88;
  border-radius: 50%;
  box-shadow: 0 0 8px #00ff88;
}

/* 右侧视觉区 */
.right-visual {
  flex: 1;
  position: relative;
  height: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* 角标 */
.corner {
  position: absolute;
  width: 25px;
  height: 25px;
  border: 2px solid #00ff88;
}

.c-tl {
  top: 0;
  left: 0;
  border-right: none;
  border-bottom: none;
}

.c-tr {
  top: 0;
  right: 0;
  border-left: none;
  border-bottom: none;
}

.c-bl {
  bottom: 0;
  left: 0;
  border-right: none;
  border-top: none;
}

.c-br {
  bottom: 0;
  right: 0;
  border-left: none;
  border-top: none;
}

/* 地球与轨道容器 */
.globe-container {
  position: relative;
  width: 350px;
  height: 350px;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* 地球（颜色淡一点） */
.globe-sphere {
  width: 180px;
  height: 180px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(0, 255, 136, 0.2) 0%, rgba(0, 255, 136, 0.02) 60%, transparent 100%);
  border: 1px solid rgba(0, 255, 136, 0.2);
  box-shadow: 0 0 20px rgba(0, 255, 136, 0.1), inset 0 0 20px rgba(0, 255, 136, 0.1);
  position: absolute;
}

/* 内部旋转的虚线球体 */
.dashed-sphere {
  position: absolute;
  width: 200px;
  height: 200px;
  border: 1px dashed rgba(0, 255, 136, 0.4);
  /* 虚线 */
  border-radius: 50%;
  animation: spin 15s linear infinite;
}

.orbit {
  position: absolute;
  border-radius: 50%;
  border: 1px dashed rgba(0, 255, 136, 0.2);
}

.orbit-1 {
  width: 250px;
  height: 250px;
  animation: spin 20s linear infinite;
}

.orbit-2 {
  width: 300px;
  height: 300px;
  animation: spin 30s linear infinite reverse;
}

.orbit-3 {
  width: 350px;
  height: 350px;
  animation: spin 40s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

/* 散落的点 */
.dot {
  position: absolute;
  background: #00ff88;
  border-radius: 50%;
  box-shadow: 0 0 10px #00ff88;
  animation: pulse 2s infinite;
}

.d1 {
  width: 8px;
  height: 8px;
  top: 10%;
  left: 30%;
}

.d2 {
  width: 5px;
  height: 5px;
  top: 20%;
  right: 10%;
  animation-delay: 0.5s;
}

.d3 {
  width: 6px;
  height: 6px;
  bottom: 30%;
  left: 15%;
  animation-delay: 1s;
}

.d4 {
  width: 4px;
  height: 4px;
  bottom: 10%;
  right: 20%;
  animation-delay: 1.5s;
}

.d5 {
  width: 10px;
  height: 10px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation-delay: 0.2s;
}

@keyframes pulse {
  0% {
    transform: scale(0.8);
    opacity: 0.5;
  }

  50% {
    transform: scale(1.2);
    opacity: 1;
  }

  100% {
    transform: scale(0.8);
    opacity: 0.5;
  }
}

/* 浮动标签框（持续上下浮动） */
.floating-label {
  position: absolute;
  background: #0d1117;
  border: 1px solid #00ff88;
  padding: 10px 20px;
  border-radius: 4px;
  font-family: monospace;
  font-weight: bold;
  font-size: 0.9rem;
  color: #fff;
  display: flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0 0 15px rgba(0, 255, 136, 0.2);
  animation: float 4s ease-in-out infinite;
  /* 浮动动画 */
}

.label-dot {
  width: 8px;
  height: 8px;
  background: #00ff88;
  border-radius: 50%;
  box-shadow: 0 0 8px #00ff88;
}

.label-1 {
  top: 60px;
  left: 0;
  animation-delay: 0s;
}

.label-2 {
  top: 180px;
  right: 0;
  animation-delay: 1s;
}

.label-3 {
  bottom: 180px;
  left: 0;
  animation-delay: 2s;
}

.label-4 {
  bottom: 60px;
  right: 0;
  animation-delay: 3s;
}

@keyframes float {

  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-10px);
  }
}

/* 响应式适配 */
@media (max-width: 900px) {
  .cta-container {
    flex-direction: column;
    text-align: center;
    gap: 40px;
  }

  .left-content {
    max-width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .buttons {
    flex-direction: column;
    width: 100%;
  }

  .btn-primary,
  .btn-secondary {
    width: 100%;
  }

  .stats {
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }

  .right-visual {
    width: 100%;
    height: 400px;
    margin-top: 30px;
  }

  /* 小屏适当缩小地球 */
  .globe-container {
    transform: scale(0.8);
  }
}

@media (max-width: 768px) {
  .main-title {
    font-size: 2.5rem;
  }

  .right-visual {
    display: none;
    /* 极小屏隐藏复杂图形保证阅读体验 */
  }
}
</style>